import AddMember from './AddMember';
import Icon from '@mdi/react';
import { mdiInformationSlabCircleOutline } from '@mdi/js';
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../../utils/firebase";
import { _saveNewGroupMember, _removeMemberFromGroup, _toggleAdmin, _updateMemberDisplayName } from "../../data/groupMembers";
import { _toggleInactiveUser } from "../../data/groups";
import { toggleModal } from "../../utils/uiUtils";
import { useCurrentGroupMembersStore } from "../../stores/useCurrentGroupMembersStore";
import { useState, useEffect } from "react";


export const GroupMembersListOnly = ({ groupId, limit, showAddMember }) => {
    const [isLoading, setIsLoading] = useState(true);

    const _getGroupMembers = useCurrentGroupMembersStore((state) => state.fetchGroupMembers);
    const _updateMemberOnSnapshot = useCurrentGroupMembersStore((state) => state.updateMemberOnSnapshot);
    const members = useCurrentGroupMembersStore((state) => state.groupMembers.members);

    const init = async () => {

        if (members) {
            setIsLoading(false);
            return;
        }

        await _getGroupMembers(groupId);
    };

    useEffect(() => {
        init();
    }, []);

    const memberRef = collection(db, 'groups', groupId, 'members');

    useEffect(() => {
        const trackMembers = onSnapshot(memberRef, (snapshot) => {
            snapshot.docChanges().forEach((change) => {
                _updateMemberOnSnapshot(groupId, change.doc.id, change.doc.data(), change.type);
            });
        });

        return () => {
            trackMembers(); // Unsubscribe from the snapshot listener when the component unmounts
        };
    }, []);

    return (
        <>
            {/* Use a Card with a heard instead with materialize menu up and menu down icons  */}
            <div className="box has-background-info-95 has-wrap-anywhere">
                <div className="is-size-6 has-text-weight-semibold">
                    Group Members <Icon path={mdiInformationSlabCircleOutline} size={.75} color="black" onClick={() => toggleModal("modal-groupMemberInfo")} /><br />
                </div>
                {showAddMember &&
                    <>
                        <div className="has-text-centered is-fullwidth">
                            <AddMember addMember={_saveNewGroupMember} groupId={groupId} buttonClass="is-primary is-rounded is-small is-outlined mr-5" />
                        </div>
                    </>
                }

                {members && Object.keys(members).sort((a, b) => { return members[a].displayName.localeCompare(members[b].displayName) }).slice(0, limit || 1000).map((memberId, index) => {
                    return (
                        <div key={"memberList_" + index}>
                            {members[memberId].displayName}
                        </div>
                    )
                })}
            </div>

            <div id="modal-groupMemberInfo" className="modal">
                <div className="modal-background"></div>
                <div className="modal-card">
                    <header className="modal-card-head has-text-centered">
                        <p className="modal-card-title">Group Members</p>
                        <button className="delete" aria-label="close" onClick={() => { toggleModal('modal-groupMemberInfo') }}></button>
                    </header>
                    <section className="modal-card-body">
                        <div className="is-size-6">
                            <li>The member list is used primarily to pre-fill the names for the games you log</li>
                            <li>Any member of the group can add a member </li>
                            <li>Members can be removed by only by an admin of the group</li>
                            <li>When you send the ivite link to members and they join they can link their name to their account</li>
                        </div>
                    </section>
                    <footer className="modal-card-foot">
                        <button className="button" aria-label="close" onClick={() => { toggleModal('modal-groupMemberInfo') }}>Close</button>
                    </footer>
                </div>
            </div>
        </>
    )
}